export const MODAL_TITLE = 'Total Basic Cost';
